import React from 'react';
import { IndexLink } from 'react-router';

import _ from "i18n";

const Home = () => {
  return (
    <li>
      <IndexLink to="/" activeClassName="active" className="menu__link">{_('home')}</IndexLink>
    </li>
  );
};

export default Home;



// WEBPACK FOOTER //
// ./app/components/menu/Home.js